import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { listLocales } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { ActiveTypeEnum } from '../../../core/enums/master.enum';
import { EquipmentDetail } from '../../../models/shared-component/equipment-detail-model';
import { FiscalYear } from '../../../models/shared-component/fiscal-year';
import { ShareService } from '../../../services/shared.service';

@Component({
  selector: 'app-equipment-detail-modal',
  templateUrl: './equipment-detail-modal.component.html',
  styleUrls: ['./equipment-detail-modal.component.scss']
})
export class EquipmentDetailModalComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public sharedService: ShareService,
    private localeService: BsLocaleService,

  ) { }

  @Input() public title: string = "";
  @Input() public titleStatus: string = "";
  @Input() public isView: boolean = false;
  @Input() public itemId: number;
  @Input() public itemDetail: EquipmentDetail;
  @Input() public callback: Function
  @Output() res = new EventEmitter<boolean>();
  @Input() public itemType: number;
  @Input() public defaultItem: string = "";

  @Input() public isMultipleEquipment: boolean =false;

  form: FormGroup;

  activeTypeStatus = ActiveTypeEnum;
  requiredName: boolean = false;

  fiscalYear$ = new BehaviorSubject<FiscalYear[] | null>(null);
  procurementType$ = new BehaviorSubject<FiscalYear[] | null>(null);

  locale = 'th-be';
  locales = listLocales();
  isParcel: boolean = false;

  async ngOnInit(): Promise<void> {
    this.initialForm();
    this.checkItemType();
    this.localeService.use(this.locale);

    const [
      fiscalYear,
      procurementType
    ] = await Promise.all([
      firstValueFrom(this.sharedService.getFiscalYear()),
      firstValueFrom(this.sharedService.getProcurementType()),

    ]);

    this.fiscalYear$.next(fiscalYear);
    this.procurementType$.next(procurementType);


    if (this.itemId) {
      this.itemDetail.multipleEquipment?.forEach((item) => {
        this.addMultitpleEquipment(item);
      })

      this.form.patchValue(this.itemDetail);
    }
    else{
      this.addMultitpleEquipment();
    }
  }

  initialForm() {
    this.form = this.formBuilder.group({
      equipmentCustomName: [this.defaultItem, Validators.required],
      equipmentNumber: [null, Validators.required],
      fiscalYearId: [null, Validators.required],
      receiveDate: [null, Validators.required],
      equipmentStatus: [null, Validators.required],
      isActive: [true],
      procurementTypeId: [null],
      contractNo: [null],
      dated: [null],
      assetNoGfmis: [null],
      pricePerUnit: [null],
      workPeriod: [null],

      multipleEquipment: this.formBuilder.array([]) 
    });

    if (this.isView) {
      this.form.disable();
    }

    if(this.isMultipleEquipment){
      this.form.get('equipmentNumber')?.clearValidators();
      this.form.get('fiscalYearId')?.clearValidators();
      this.form.get('receiveDate')?.clearValidators();
      this.form.get('equipmentStatus')?.clearValidators();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  isFormInvalid(formControlName: string): boolean {
    return (this.form.controls[formControlName].touched || this.form.controls[formControlName].dirty) && this.form.controls[formControlName].invalid
  }

  onSave() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => { this.form.controls[key].markAsTouched(); });
      this.form.markAllAsTouched();
      return;
    }

    var returnData = this.form.getRawValue() as EquipmentDetail;
    this.callback(returnData);
  }

  checkItemType() {
    if (this.itemType == 1) {
      this.isParcel = true;
    }
  }

  addMultitpleEquipment(item?: EquipmentDetail){
    const mulControl = this.multipleEquipment;

    const mulGroup = this.formBuilder.group({
      equipmentCustomName: [item?.equipmentCustomName, Validators.required],
      equipmentNumber: [item?.equipmentNumber, Validators.required],
      fiscalYearId: [item?.fiscalYearId, Validators.required],
      receiveDate: [item?.receiveDate, Validators.required],
      equipmentStatus: [item?.equipmentStatus, Validators.required],
      isActive: [item?.isActive ?? true],
      procurementTypeId: [item?.procurementTypeId],
      contractNo: [item?.contractNo],
      dated: [item?.dated],
      assetNoGfmis: [item?.assetNoGfmis],
      pricePerUnit: [item?.pricePerUnit],
      workPeriod: [item?.workPeriod],
    });

    if(this.isView){
      mulGroup.disable();
    }

    mulControl.push(mulGroup);
  
  }

  deleteMultipleEquipment(index: number){
    const mulControl = this.form.get('multipleEquipment') as FormArray;

    mulControl.removeAt(index);
  }

  get multipleEquipment(): FormArray {
    return this.form.get('multipleEquipment') as FormArray;
  }

  isInvalid(path: string | (string | number)[]): boolean {
    const ctrl = this.form.get(Array.isArray(path) ? path : path);
    if (!ctrl) return false; // or true if you want to be strict
    const interacted = ctrl.touched || ctrl.dirty;
    return interacted && ctrl.invalid;
  }
  
  hasError(path: string | (string | number)[], errorCode: string): boolean {
    const ctrl = this.form.get(Array.isArray(path) ? path : path);
    return !!ctrl && (ctrl.touched || ctrl.dirty) && ctrl.hasError(errorCode);
  }
}
